import {Component, computed, input, Input, OnChanges, viewChild} from '@angular/core';
import {ChartComponent, ChartDataSet, ChartOptions} from 'src/app/shared/components/chart/chart.component';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {FinanceDashboardChartPresentationType, FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';
import { FinanceDashboardBarChartOptions, FinanceDashboardPieChartOptions } from '../../constants/finance-dashboard-chart-options';

@Component({
  selector: 'app-generic-chart',
  templateUrl: './generic-chart.component.html',
  standalone: false,
})

@AutoUnsubscribe()
export class GenericChartComponent implements OnChanges {
  public readonly chart = viewChild.required(ChartComponent);

  @Input() presentationType: FinanceDashboardChartPresentationType = FinanceDashboardChartPresentationType.Amount;
  @Input() data: any;
  @Input() chartConfiguration!: any;
  public readonly options = input<ChartOptions>();

  public chartDataSet!: ChartDataSet | null;
  public readonly chartOptions = computed(() => {
    const options = this.options();
    if (options) return options;
    return this.chartConfiguration.chartType === FinanceDashboardChartType.Pie ? FinanceDashboardPieChartOptions : FinanceDashboardBarChartOptions;
  });

  ngOnChanges(): void {
    this.createChart(this.data.labels, this.data);
  }

  createChart(labels: string[], data: any) {
    this.chartDataSet = {
      labels: labels,
      datasets: [{
        data: this.presentationType === FinanceDashboardChartPresentationType.Amount ? data?.amount : data?.percentage,
        backgroundColor: this.chartConfiguration.backGroundColor,
        borderColor: this.chartConfiguration.borderColor,
        label: this.chartConfiguration.label,
        barPercentage: this.chartConfiguration.barPercentage,
        categoryPercentage: this.chartConfiguration.categoryPercentage,
        borderWidth: this.chartConfiguration.borderWidth
      }]
    };
  }
}
